import React, {useEffect, useState} from "react";
import LandingPage from "../LandingPage";
import {apiAdminLandingPreview} from "../api/landing";

// Aperçu de la landing pour l'administration : la vraie page, alimentée par le brouillon (résolu) via une route
// protégée. Affichée dans l'iframe de l'onglet Admin « Landing ». Sans droit ou sans jeton : simple message.
export default function LandingPreviewPage({user}) {
    const [state, setState] = useState({loading: true});

    useEffect(() => {
        let cancelled = false;
        apiAdminLandingPreview().then(result => {
            if (cancelled) return;
            setState(result && !result.error && result.page ? {page: result.page} : {denied: true});
        });
        return () => { cancelled = true; };
    }, []);

    if (state.loading) return <p style={{padding: 24}}>Chargement de l'aperçu…</p>;
    if (state.denied) return <p style={{padding: 24}}>Aperçu réservé aux administrateurs.</p>;
    return <LandingPage user={user} page={state.page} onGoToApp={() => {}} onRegister={() => {}}/>;
}
